import { MAP_CATALOG_PARAMS_KEYS_REMOTE_LOCAL } from '@diagnostics/config'
import useObjectKeyConverter from '@core/hooks/useObjectKeyConverter'

export const {
  convertForward: convertCatalogParamsRemoteToLocal,
  convertReverse: convertCatalogParamsLocalToRemote
} = useObjectKeyConverter(MAP_CATALOG_PARAMS_KEYS_REMOTE_LOCAL)
